import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAr = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 87 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(3 21)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M59-1c.552 0 1.052.224 1.414.586C60.776-.052 61 .448 61 1h0v23H-1V1c0-.552.224-1.052.586-1.414A1.994 1.994 0 011-1h0z",
				stroke: "#0D0E10",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61 24v8H35.93a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0129 38a6.977 6.977 0 01-4.856-1.958 6.985 6.985 0 01-2.043-3.85h0l-4.177-.157a6.981 6.981 0 01-1.974 3.915A6.978 6.978 0 0111 38a6.977 6.977 0 01-4.856-1.958 6.985 6.985 0 01-2.046-3.866h0L.968 32a1.994 1.994 0 01-1.382-.586A1.994 1.994 0 01-1 30h0v-6h62zM73.53 5a2.996 2.996 0 012.863 2.105h0l4.47 14.305a3 3 0 01.137.895h0V30c0 .552-.224 1.052-.586 1.414A1.994 1.994 0 0179 32h0-2.07a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0170 38a6.977 6.977 0 01-4.856-1.958 6.985 6.985 0 01-2.053-3.913h0L61 31.894V20h4V7c0-.552.224-1.052.586-1.414A1.994 1.994 0 0167 5h0z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0D0E10",
				d: "M69 6h2v13h-2zM66 19h14v2H66z"
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 11,
				cy: 32,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 29,
				cy: 32,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 70,
				cy: 32,
				r: 2
			})
		]
	})
});
export default SvgAr;
